import {createAction} from '@reduxjs/toolkit';

export const updateParityDropdown = createAction('discreteParity/updateDiscreteParity');
